/* eslint-disable react/require-default-props */
/* eslint-disable consistent-return */
import React, { useRef, useEffect } from 'react';
import { throttle } from 'underscore';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { LayoutSize } from '@bingads-webui-fluent-component/layout-size';
import { DefaultTemplate } from './template';
import { MenuContext } from './menu-context';
import { GlobalNavContainerProps } from './types';

const useStyles = makeStyles({
  container: {
    height: '60px',
    backgroundColor: tokens.colorNeutralBackground5,
    paddingLeft: '24px',
    paddingRight: '24px',
  },
});

export const GlobalNavContainer: React.FC<GlobalNavContainerProps> = ({
  children = [],
  template: Template = DefaultTemplate,
  getLayoutSize,
  className,
  ...templateProps
}) => {
  const classes = useStyles();
  const [layoutSize, setLayoutSize] = React.useState<LayoutSize>(LayoutSize.S);
  const resizedContainerRef = useRef<HTMLDivElement>(null);
  const [singleComponentModeKey, setSingleComponentModeKey] = React.useState<string | undefined>(undefined);
  const [dynamicallyPinedItemKey, setDynamicallyPinedItemKey] = React.useState<string | undefined>(undefined);

  const updateMode = (key: string | undefined) => {
    setSingleComponentModeKey(key);
  };
  const updatePinedItemKey = (key: string | undefined) => {
    setDynamicallyPinedItemKey(key);
  };

  useEffect(() => {
    const observer = new (window as any).ResizeObserver(throttle((entries: any[]) => {
      // Do something when the element is resized
      const entry = entries[0];

      // Decide whether to adjust virtual scrollbar
      const { width } = entry.contentRect;
      const newLayoutSize = getLayoutSize(width);
      setLayoutSize(newLayoutSize);
    }, 10));

    observer.observe(resizedContainerRef.current);

    return () => {
      observer.disconnect();
    };
  }, [getLayoutSize, layoutSize, resizedContainerRef]);

  const childrenArray = React.Children.toArray(children);

  return (
    <MenuContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        layoutSize,
        singleComponentModeKey,
        updateMode,
        updatePinedItemKey,
        dynamicallyPinedItemKey,
      }}
    >
      <nav ref={resizedContainerRef} className={mergeClasses(classes.container, className)}>
        <Template items={childrenArray} {...templateProps} />
      </nav>
    </MenuContext.Provider>
  );
};
